import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AdminRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="glass-strong rounded-2xl px-8 py-6 flex items-center gap-3">
                    <Loader2 className="w-4 h-4 text-lab-blue animate-spin" />
                    <span className="lab-mono text-xs text-white">Verifying admin clearance…</span>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/" replace />;
    if (user.role !== 'admin') return <Navigate to="/" replace />;
    return children;
}
